import React from "react";
import { Button, Container, Typography, Box } from "@mui/material";
import { Link } from "react-router-dom";

const NotFound = () => {
	return (
		<Container
			sx={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				height: "100vh",
				textAlign: "center",
			}}
		>
			<Box sx={{ maxWidth: 500, mb: 4 }}>
				<svg
					xmlns='http://www.w3.org/2000/svg'
					viewBox='0 0 24 24'
					fill='none'
					stroke='currentColor'
					strokeWidth='1.5'
					strokeLinecap='round'
					strokeLinejoin='round'
					className='w-full h-auto text-gray-500'
				>
					<path d='M9 10h.01M15 10h.01M8 15h8M12 2a10 10 0 100 20 10 10 0 000-20z' />
				</svg>
			</Box>

			<Typography variant='h2' component='h1' gutterBottom>
				404
			</Typography>

			<Typography variant='h6' color='textSecondary' paragraph>
				Oops! The page you're looking for doesn't exist.
			</Typography>

			<Button variant='contained' component={Link} to='/' sx={{ mt: 3 }}>
				Go to Dashboard
			</Button>
		</Container>
	);
};

export default NotFound;
